/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerLockDto } from '../models/customer-lock-dto';
import { getBillableServiceCustomerLock } from '../fn/customer-lock-controller/get-billable-service-customer-lock';
import { GetBillableServiceCustomerLock$Params } from '../fn/customer-lock-controller/get-billable-service-customer-lock';


/**
 * Manages state on locked customers while billable services are created.
 */
@Injectable({ providedIn: 'root' })
export class CustomerLockControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBillableServiceCustomerLock()` */
  static readonly GetBillableServiceCustomerLockPath = '/customers/{customerId}/billable-services/customer-lock';

  /**
   * Get hints for locked customers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBillableServiceCustomerLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillableServiceCustomerLock$Response(params: GetBillableServiceCustomerLock$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerLockDto>> {
    return getBillableServiceCustomerLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Get hints for locked customers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBillableServiceCustomerLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillableServiceCustomerLock(params: GetBillableServiceCustomerLock$Params, context?: HttpContext): Observable<CustomerLockDto> {
    return this.getBillableServiceCustomerLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerLockDto>): CustomerLockDto => r.body)
    );
  }

}
